export enum EnvVarEnum {
    PRODUCTION = 'PROD',
    DEVELOPMENT = 'DEV',
    TESTING = 'TEST',
}